import React from "react";
import { graphql } from "gatsby";
import { Accordions } from "./Accordions";
import {
  KontentComponentSettings,
  KontentRichText,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";

type KontentAccordion = {
  elements: {
    content_category: {
      value: {
        name?: string;
      };
    };
    label: StringValue;
    text: KontentRichText;
  };
};

interface Props extends KontentComponentSettings {
  heading: StringValue;
  accordion_items: KontentRichText;
}

const AccordionsContainer: React.FC<Props> = ({
  heading,
  accordion_items,
  ...props
}) => {
  const settings = getComponentSettings({ ...props });

  const formatAccordions = (accordions: KontentAccordion[]) => {
    return accordions.map((acc) => {
      return {
        label: acc.elements.label?.value,
        text: acc.elements.text,
        contentCategory: acc.elements?.content_category.value[0]?.name,
      };
    });
  };

  return (
    <Accordions
      {...settings}
      heading={heading.value}
      accordions={formatAccordions(accordion_items?.modular_content)}
    ></Accordions>
  );
};

export default AccordionsContainer;

export const fragmentAccordionsContainer = graphql`
  fragment Accordions on kontent_item_accordions {
    elements {
      accordion_items {
        modular_content {
          ... on kontent_item_accordion_item {
            id
            elements {
              label {
                value
              }
              text {
                ...kontentSimpleRichText
              }
              content_category {
                value {
                  name
                }
              }
            }
          }
        }
      }
      heading {
        value
      }
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
